import React from 'react';
import { connect } from 'react-redux';
import CyfLockup from '../utils/CyfLockup';

const LogoSide = ({ branding, isWhiteLabelApp }) => {
  const { clientWebsite, name, logo } = branding;
  const { signInLogoSideBg } = branding?.colors || {};
  const showCyfLockup = !isWhiteLabelApp;

  return (
    <div className='logoSide w-full md:w-1/2' style={{ background: signInLogoSideBg }}>
      <div className='logoDescription'>
        <button
          type='button'
          className='bg-transparent border-0 p-0 cursor-pointer'
          onClick={() => window.open(`https://${clientWebsite}`, '_blank')}>
          {showCyfLockup ? (
            <CyfLockup variant='onDark' size='login' />
          ) : (
            <img src={logo} alt={name} className='loginLogo' />
          )}
        </button>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    branding: state.branding,
    isWhiteLabelApp: state.isWhiteLabelApp,
  };
};
export default connect(mapStateToProps, null)(LogoSide);
